export const markAsNotSpamCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
  successToast: '',
};
